import { render } from "./ImageRecorder.vue?vue&type=template&id=cf7334e8&scoped=true"
import script from "./ImageRecorder.vue?vue&type=script&lang=js"
export * from "./ImageRecorder.vue?vue&type=script&lang=js"

import "./ImageRecorder.vue?vue&type=style&index=0&id=cf7334e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf7334e8"]])

export default __exports__